import { Link } from "react-router-dom";
import { ArrowLeft, Zap } from "lucide-react";
import ThemeToggle from "./ThemeToggle";

export default function SubPageNav() {
  return (
    <div className="relative flex items-center mb-12 min-h-[44px] gap-4" data-testid="subpage-nav">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-brand-ink hover:text-brand-energy transition-colors group z-10"
        data-testid="back-home-link"
      >
        <ArrowLeft className="w-4 h-4 group-hover:-translate-x-0.5 transition-transform" />
        <span className="text-sm sm:text-base font-medium">Zurück</span>
      </Link>

      <Link
        to="/"
        aria-label="Zur Startseite"
        data-testid="page-logo-link"
        className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 inline-flex items-center gap-2.5 cursor-pointer group"
      >
        <div className="w-9 h-9 rounded-xl bg-brand-inverse flex items-center justify-center group-hover:bg-brand-energy transition-colors">
          <Zap className="w-4 h-4" style={{ color: 'var(--brand-green-neon)' }} strokeWidth={2.5} />
        </div>
        <span className="hidden sm:inline font-heading text-lg font-black tracking-tight text-brand-ink">
          Strombaron
        </span>
      </Link>

      <div className="ml-auto z-10">
        <ThemeToggle />
      </div>
    </div>
  );
}
